export const businessProduct = [
  {
    text: `-- Select --`,
    disabled: true,
    value: ``,
  },
  {
    text: `Treasury`,
    disabled: true,
    value: ``,
  },
  {
    text: `Deposit`,
    disabled: false,
    value: `Deposit`,
  },
  {
    text: `Foreign Exchange`,
    disabled: false,
    value: `Foreign Exchange`,
  },
  {
    text: `Deposits`,
    disabled: true,
    value: ``,
  },
  {
    text: `Current Account-i`,
    disabled: false,
    value: `Current Account-i`,
  },
  {
    text: `Deposits`,
    disabled: true,
    value: ``,
  },
  {
    text: `Term Deposit-i`,
    disabled: false,
    value: `Term Deposit-i`,
  },
  {
    text: `Floating Rate Term Deposit-i`,
    disabled: false,
    value: `Floating Rate Term Deposit-i`,
  },
  {
    text: `Commodity Murabahah Current Account-i`,
    disabled: false,
    value: `Commodity Murabahah Current Account-i`,
  },
  {
    text: `Commodity Murabahah Foreign Currency Current Account-i`,
    disabled: false,
    value: `Commodity Murabahah Foreign Currency Current Account-i`,
  },
  {
    text: `Financing`,
    disabled: true,
    value: ``,
  },
  {
    text: `Cashline-i`,
    disabled: false,
    value: `Cashline-i`,
  },
  {
    text: `Commodity Financing-i`,
    disabled: false,
    value: `Commodity Financing-i`,
  },
  {
    text: `Structured Commodity Financing-i`,
    disabled: false,
    value: `Structured Commodity Financing-i`,
  },
  {
    text: `Trade Finance`,
    disabled: false,
    value: `Trade Finance`,
  },
  {
    text: `Letter of Credit-i`,
    disabled: false,
    value: `Letter of Credit-i`,
  },
  {
    text: `Structured Commodity Financing-i`,
    disabled: false,
    value: `Structured Commodity Financing-i`,
  },
  {
    text: `Shipping Guarantee-i`,
    disabled: false,
    value: `Shipping Guarantee-i`,
  },
  {
    text: `Bank Guarantee-i`,
    disabled: false,
    value: `Bank Guarantee-i`,
  },
  {
    text: `Trade Commodity Financing-i`,
    disabled: false,
    value: `Trade Commodity Financing-i`,
  },
  {
    text: `Bills for Collection-i`,
    disabled: false,
    value: `Bills for Collection-i`,
  },
  {
    text: `Syndication Financing`,
    disabled: false,
    value: `Syndication Financing`,
  },
  {
    text: `Global Markets`,
    disabled: true,
    value: ``,
  },
  {
    text: `Financial Institutions`,
    disabled: false,
    value: `Financial Institutions`,
  },
  {
    text: `Cash Management`,
    disabled: true,
    value: ``,
  },
  {
    text: `alrajhicashbiz@24seven`,
    disabled: false,
    value: `alrajhicashbiz@24seven`,
  },
  {
    text: `e-Payment`,
    disabled: false,
    value: `e-Payment`,
  },
];

export const personalProduct = [
  {
    text: `-- Select --`,
    disabled: true,
    value: ``,
  },
  {
    text: `Deposit`,
    disabled: true,
    value: ``,
  },
  {
    text: `Savings Account-i`,
    disabled: false,
    value: `savings-account-i`,
  },
  {
    text: `Current Account-i`,
    disabled: false,
    value: `current-account-i`,
  },
  {
    text: `Commodity Murabahah Term Deposit-i`,
    disabled: false,
    value: `commodity-murabahah-term-deposit-i`,
  },
  {
    text: `Commodity Murabahah Savings Account-i`,
    disabled: false,
    value: `commodity-murabahah-savings-account-i`,
  },
  {
    text: `Commodity Murabahah Current Account-i`,
    disabled: false,
    value: `commodity-murabahah-current-account-i`,
  },
  {
    text: `Commodity Murabahah Foreign Currency Current Account-i`,
    disabled: false,
    value: `commodity-murabahah-foreign-currency-current-account-i`,
  },
  {
    text: `Cards`,
    disabled: true,
    value: ``,
  },
  {
    text: `alrajhi bank Malaysia Debit Card-i`,
    disabled: false,
    value: `debit-card-i`,
  },
  {
    text: `alrajhi bank Malaysia Rafahia Card-i`,
    disabled: false,
    value: `rafahia-card-i`,
  },
  {
    text: `Personal Financing`,
    disabled: true,
    value: ``,
  },
  {
    text: `Personal Financing-i`,
    disabled: false,
    value: `personal-financing-i`,
  },
  {
    text: `Pembiayaan Peribadi-i Umrah`,
    disabled: false,
    value: `pembiayaan-peribadi-i-umrah`,
  },
  {
    text: `Personal Financing-i Secured by Term Deposit-i`,
    disabled: false,
    value: `personal-financing-i-secured-by-term-deposit-i`,
  },
  {
    text: `Personal Financing-i (EBS)`,
    disabled: false,
    value: `personal-financing-i-ebs`,
  },
  {
    text: `Corporate Community Select Programme - Salary Deduction (CCCSP-SD)`,
    disabled: false,
    value: `corporate-community-select-programme-salary-deduction`,
  },
  {
    text: `Property Financing`,
    disabled: true,
    value: ``,
  },
  {
    text: `Home Financing`,
    disabled: false,
    value: `home-financing`,
  },
  {
    text: `Home One Account`,
    disabled: false,
    value: `home-one-account`,
  },
  {
    text: `Business Premises Financing-i`,
    disabled: false,
    value: `business-premises-financing-i`,
  },
  {
    text: `Wealth Management`,
    disabled: true,
    value: ``,
  },
  {
    text: `Gold-<i>i</i>`,
    disabled: false,
    value: `gold-i`,
  },
  {
    text: `GoldInvest-<i>i</i>`,
    disabled: false,
    value: `goldinvest-i`,
  },
  {
    text: `Unit Trust`,
    disabled: false,
    value: `unit-trust`,
  },
  {
    text: `Structured Product-i`,
    disabled: false,
    value: `structured-product-i`,
  },
  {
    text: `BancaTakaful`,
    disabled: true,
    value: ``,
  },
  {
    text: `Sinar Link Aiman`,
    disabled: false,
    value: `sinar-link-aiman`,
  },
  {
    text: `Structured Product-i`,
    disabled: false,
    value: `structured-product-i-2`,
  },
  {
    text: `digital`,
    disabled: true,
    value: ``,
  },
  {
    text: `alrajhi@24seven`,
    disabled: false,
    value: `alrajhi-24seven`,
  },
  {
    text: `Rize`,
    disabled: false,
    value: `rize`,
  },
  {
    text: `Promotions`,
    disabled: true,
    value: ``,
  },
  {
    text: `alrajhi bank Malaysia 5kali3 Cashback Campaign`,
    disabled: false,
    value: `cashback-campaign`,
  },
  {
    text: `Work Hard Save Easy Campaign`,
    disabled: false,
    value: `work-hard-save-easy`,
  },
  {
    text: `Discover Hidden Returns Campaign`,
    disabled: false,
    value: `discover-hidden-returns`,
  },
  {
    text: `Pembiayaan Peribadi-i Umrah`,
    disabled: false,
    value: `pembiayaan-peribadi-i-umrah-2`,
  },
  {
    text: `Gold For Your Goals 2.0 Campaign`,
    disabled: false,
    value: `gold-for-your-goals`,
  },
  {
    text: `Your preferred Travel Companion for your Pilgrimage Journey`,
    disabled: false,
    value: `travel-companion-pilgrimage`,
  },
  {
    text: `Others`,
    disabled: true,
    value: ``,
  },
  {
    text: `Affluent Proposition`,
    disabled: false,
    value: `affluent-proposition`,
  },
];
